import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DmpHome from "./assets/DmpHome.jpg";
import DmpCard from "./DmpCard";
import DmpNumbers from "./DmpNumbers";
import DmpTimeline from "./DmpTimeline";
import DmpRoadmap from "./DmpRoadmap";
import Faq from "./DmpFaqs";
import Feedback from "./feedbackdmp";
import InfoMarquee from "./InfoMarquee"; // <-- Import the InfoMarquee component

const Dmp = () => {
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();

  // ────── HERO STYLES (unchanged) ──────
  const heroStyle = {
    position: "relative",
    minHeight: "30vh",
    backgroundImage: "url('https://codeforgovtech.in/wp-content/uploads/2024/03/Group-1244830747-3.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
    overflow: "hidden",
    padding: "2rem 1rem",
    boxShadow: "0 2px 16px rgba(122,0,82,0.10)", // Optional: soft shadow
  };
  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to bottom, rgba(122,0,82,0.8), rgba(68,0,102,0.8))",
    zIndex: 1,
    borderRadius: "12px", // Match heroStyle if using rounded corners
  };
  const contentStyle = { position: "relative", zIndex: 2, maxWidth: "900px", width: "100%" };
  const headingStyle = { fontSize: "clamp(1.8rem,5vw,2.4rem)", fontWeight: "bold", marginBottom: "1.2rem", fontFamily: "'Nunito Sans', Arial, sans-serif" };
  const buttonContainerStyle = { display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "0.8rem", marginTop: "1rem" };
  const btnBase = { padding: "0.6rem 1.2rem", borderRadius: "8px", fontSize: "clamp(0.9rem,2.5vw,1rem)", fontWeight: "600", cursor: "pointer", transition: "all .3s", whiteSpace: "nowrap" };
  const btnOutline = { ...btnBase, background: "transparent", color: "#fff", border: "2px solid #fff" };
  const btnOutlineHover = { background: "#fff", color: "#7e0054" };
  const btnYellow = { ...btnBase, background: "#ffca28", color: "#000", fontWeight: "bold", border: "none" };
  const btnYellowHover = { background: "#ffd54f" };

  // ────── PAGE-WIDE WRAPPER ──────
  const pageWrapper = {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 1rem",
  };

  // ────── SECTION SPACING (only between sections) ──────
  const sectionSpacer = { marginTop: "2rem" };   // adjust as you like

  return (
    <>
      {/* ────── HERO ────── */}
      {/* <section style={heroStyle}>
        <div style={overlayStyle} />
        <div style={contentStyle}>
          <h1 style={headingStyle}>Dedicated Mentoring Program</h1>

          <div style={buttonContainerStyle}>
            {["About the Program", "Mentor Cohort", "Contributor Cohort"].map((txt, i) => (
              <button
                key={i}
                style={hovered === i ? { ...btnOutline, ...btnOutlineHover } : btnOutline}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  if (txt === "DMP 2025") navigate("/dmp2025");
                }}
              >
                {txt}
              </button>
            ))} */}

            {/* <button
              style={hovered === "yellow" ? { ...btnYellow, ...btnYellowHover } : btnYellow}
              onMouseEnter={() => setHovered("yellow")}
              onMouseLeave={() => setHovered(null)}
            >
              Apply Now
            </button> */}
          {/* </div>
        </div>
      </section> */}

      {/* ────── INFO MARQUEE ────── */}
      <InfoMarquee />

      {/* ────── CONTENT SECTIONS ────── */}
      <div style={pageWrapper}>
        <DmpCard />
        <div style={sectionSpacer}>
          <DmpNumbers />
        </div>
        {/* <div style={sectionSpacer}>
          <DmpTimeline />
        </div> */}
        <div style={sectionSpacer}>
          <DmpRoadmap />
        </div>
        <Feedback />

        <Faq />

      </div>
    </>
  );
};

export default Dmp;